var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "other-link" }, [
    _vm.config.superappDownloadUrl != null &&
    _vm.config.superappDownloadUrl != ""
      ? _c(
          "div",
          { staticClass: "download-app" },
          [
            _c(
              "el-popover",
              { attrs: { placement: "left", width: "200", trigger: "hover" } },
              [
                _c("img", {
                  attrs: {
                    src: _vm.superappDownloadQrCodeImgUrl,
                    width: "200",
                    height: "200"
                  }
                }),
                _c(
                  "span",
                  {
                    staticStyle: { display: "flex", "align-items": "center" },
                    attrs: { slot: "reference" },
                    slot: "reference"
                  },
                  [
                    _c("i", {
                      staticClass: "su-icon-qrcode down-loadQrcode",
                      style: { color: "#" + _vm.config.schemeColor }
                    }),
                    _c(
                      "span",
                      {
                        style: { color: "#" + _vm.config.schemeColor },
                        attrs: { href: "" }
                      },
                      [_vm._v("下载APP")]
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.config.activeAccountRedirectUrl != null &&
    _vm.config.activeAccountRedirectUrl != ""
      ? _c("div", [
          _c(
            "a",
            {
              style: { color: "#" + _vm.config.schemeColor },
              attrs: { href: _vm.activeAccountRedirectUrl, target: "_blank" }
            },
            [_vm._v("账号激活")]
          )
        ])
      : _vm._e(),
    _vm.config.forgotPasswordRedirectUrl != null &&
    _vm.config.forgotPasswordRedirectUrl != ""
      ? _c("div", [
          _c(
            "a",
            {
              style: { color: "#" + _vm.config.schemeColor },
              attrs: { href: _vm.forgotPasswordRedirectUrl, target: "_blank" }
            },
            [_vm._v("忘记密码？")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }